'use strict';

module.exports = {
  breakpoints: {
    navCollapse: 500,
  },
};
